export function Eq5dlIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 63">
      <path d="M62.321 20.418H42.908V1.005h-22.34v19.413H1.155v22.339h19.413V62.17h22.34V42.757h19.413z" />
    </svg>
  );
}
